(function () {
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var mobileMenuLabel = menuToggle?.querySelector('[data-mobile-menu-label]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      var nextIsOpen = !isOpen;
      menuToggle.setAttribute('aria-expanded', String(nextIsOpen));
      mobileMenu.hidden = isOpen;
      if (mobileMenuLabel) mobileMenuLabel.textContent = nextIsOpen ? 'Close menu' : 'Open menu';
      if (nextIsOpen) mobileMenu.querySelector('a')?.focus();
    });

    mobileMenu.addEventListener('click', function (event) {
      if (event.target.closest('a')) {
        menuToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.hidden = true;
        if (mobileMenuLabel) mobileMenuLabel.textContent = 'Open menu';
      }
    });
  }

  var carousels = document.querySelectorAll('[data-carousel]');
  for (var carousel of carousels) {
    var slides = carousel.querySelectorAll('[data-carousel-slide]');
    var dots = carousel.querySelectorAll('[data-carousel-dot]');
    var previous = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    var toggle = carousel.querySelector('[data-carousel-toggle]');
    var toggleIcon = toggle?.querySelector('.icon');
    var current = 0;
    var timer = null;
    var isPaused = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (slides.length < 2) continue;

    var showSlide = function (index) {
      current = (index + slides.length) % slides.length;
      for (var i = 0; i < slides.length; i += 1) {
        var isActive = i === current;
        slides[i].hidden = !isActive;
        slides[i].setAttribute('aria-hidden', String(!isActive));
      }
      for (var dot of dots) {
        var isCurrent = Number(dot.dataset.carouselDot) === current;
        dot.classList.toggle('is-active', isCurrent);
        if (isCurrent) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      }
    };

    var stopTimer = function () {
      if (timer !== null) window.clearInterval(timer);
      timer = null;
    };

    var startTimer = function () {
      stopTimer();
      if (reducedMotion || isPaused) return;
      timer = window.setInterval(function () { showSlide(current + 1); }, 2000);
    };

    previous?.addEventListener('click', function () { showSlide(current - 1); startTimer(); });
    next?.addEventListener('click', function () { showSlide(current + 1); startTimer(); });
    for (var dot of dots) {
      dot.addEventListener('click', function (event) {
        showSlide(Number(event.currentTarget.dataset.carouselDot));
        startTimer();
      });
    }

    toggle?.addEventListener('click', function () {
      isPaused = !isPaused;
      toggle.setAttribute('aria-pressed', String(isPaused));
      toggle.setAttribute('aria-label', isPaused ? 'Resume slideshow' : 'Pause slideshow');
      toggleIcon?.classList.toggle('icon--play', isPaused);
      toggleIcon?.classList.toggle('icon--pause', !isPaused);
      startTimer();
    });

    carousel.addEventListener('mouseenter', stopTimer);
    carousel.addEventListener('mouseleave', startTimer);
    carousel.addEventListener('focusin', stopTimer);
    carousel.addEventListener('focusout', function (event) {
      if (!carousel.contains(event.relatedTarget)) startTimer();
    });

    showSlide(0);
    startTimer();
  }
}());

(function () {
  var carousels = document.querySelectorAll('[data-product-carousel]');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var bindProductCarousel = function (carousel) {
    var track = carousel.querySelector('[data-product-carousel-track]');
    var previous = carousel.querySelector('[data-product-carousel-prev]');
    var next = carousel.querySelector('[data-product-carousel-next]');
    if (!track) return;

    var getStep = function () {
      var card = track.querySelector('.product-recommendation-card');
      if (!card) return track.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    };

    var move = function (direction) {
      if (track.scrollWidth <= track.clientWidth + 4) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var behavior = reducedMotion ? 'auto' : 'smooth';
      if (direction > 0 && track.scrollLeft >= maxScroll - 4) {
        track.scrollTo({ left: 0, behavior: behavior });
        return;
      }
      if (direction < 0 && track.scrollLeft <= 4) {
        track.scrollTo({ left: maxScroll, behavior: behavior });
        return;
      }
      track.scrollBy({ left: direction * getStep(), behavior: behavior });
    };

    previous?.addEventListener('click', function () { move(-1); });
    next?.addEventListener('click', function () { move(1); });
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        move(1);
      }
    });
  };

  for (var carousel of carousels) bindProductCarousel(carousel);
}());

(function () {
  var roots = document.querySelectorAll('[data-product-root]');

  for (var root of roots) {
    var variantsElement = root.querySelector('[data-product-variants]');
    var form = root.querySelector('[data-product-form]');
    if (!variantsElement || !form) continue;

    var variants;
    try {
      variants = JSON.parse(variantsElement.textContent);
    } catch (error) {
      console.error('Product variant data could not be read.', error);
      continue;
    }

    var priceBlock = root.querySelector('[data-product-price-block]');
    var priceElement = root.querySelector('[data-product-price]');
    var compareElement = root.querySelector('[data-product-compare-price]');
    var savingsElement = root.querySelector('[data-product-savings]');
    var variantIdElement = form.querySelector('[data-product-variant-id]');
    var addButton = form.querySelector('[data-add-to-cart]');
    var addButtonLabel = form.querySelector('[data-add-to-cart-label]');
    var paymentButton = form.querySelector('[data-payment-button]');
    var stockElement = root.querySelector('[data-stock-message]');
    var stickyCta = root.querySelector('[data-sticky-cta]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickyCompare = root.querySelector('[data-sticky-compare]');
    var stickySavings = root.querySelector('[data-sticky-savings]');
    var stickyBuyNow = root.querySelector('[data-sticky-buy-now]');
    var stickyBuyNowLabel = root.querySelector('[data-sticky-buy-now-label]');
    var stickyVisibilityWanted = false;

    var setStickyVisibility = function (shouldShow) {
      stickyVisibilityWanted = shouldShow;
      if (!stickyCta) return;
      var isAvailable = !stickyBuyNow || !stickyBuyNow.disabled;
      stickyCta.hidden = !shouldShow || !isAvailable;
      root.toggleAttribute('data-sticky-visible', !stickyCta.hidden);
    };

    var formatMoney = function (cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, priceBlock?.dataset.moneyFormat);
      }

      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
          style: 'currency',
          currency: priceBlock?.dataset.currency || 'INR'
        }).format(Number(cents) / 100);
      } catch (error) {
        return String(cents);
      }
    };

    var showPrice = function (variant) {
      if (!priceBlock || !priceElement) return;
      priceElement.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      var onSale = Number(variant.compare_at_price) > Number(variant.price);
      if (compareElement) {
        compareElement.replaceChildren();
        compareElement.hidden = !onSale;
        if (onSale) {
          var compareText = document.createElement('s');
          compareText.textContent = formatMoney(variant.compare_at_price);
          compareElement.append(compareText);
        }
      }

      if (stickyCompare) {
        stickyCompare.replaceChildren();
        stickyCompare.hidden = !onSale;
        if (onSale) {
          var stickyCompareText = document.createElement('s');
          stickyCompareText.textContent = formatMoney(variant.compare_at_price);
          stickyCompare.append(stickyCompareText);
        }
      }

      if (savingsElement) {
        savingsElement.hidden = !onSale;
        if (onSale) {
          var savings = Math.round(((Number(variant.compare_at_price) - Number(variant.price)) * 100) / Number(variant.compare_at_price));
          savingsElement.textContent = (priceBlock.dataset.saveTemplate || 'Save __PERCENT__%').replace('__PERCENT__', String(savings));
        } else {
          savingsElement.textContent = '';
        }
      }

      if (stickySavings) {
        stickySavings.hidden = !onSale;
        if (onSale) {
          var stickySavingsPercentage = Math.round(((Number(variant.compare_at_price) - Number(variant.price)) * 100) / Number(variant.compare_at_price));
          stickySavings.textContent = (priceBlock.dataset.saveTemplate || 'Save __PERCENT__%').replace('__PERCENT__', String(stickySavingsPercentage));
        } else {
          stickySavings.textContent = '';
        }
      }
    };

    var showAvailability = function (variant) {
      if (stockElement) {
        var isTracked = Boolean(variant.inventory_management);
        stockElement.hidden = !isTracked;
        if (isTracked) {
          if (!variant.available) {
            stockElement.textContent = stockElement.dataset.stockUnavailable;
          } else if (Number(variant.inventory_quantity) > 0 && Number(variant.inventory_quantity) <= 5) {
            stockElement.textContent = (stockElement.dataset.stockLow || '').replace('__COUNT__', String(variant.inventory_quantity));
          } else {
            stockElement.textContent = stockElement.dataset.stockAvailable;
          }
        }
      }

      if (addButton) {
        addButton.disabled = !variant.available;
        if (addButtonLabel) addButtonLabel.textContent = variant.available ? addButton.dataset.labelAdd : addButton.dataset.labelSoldOut;
      }
      if (paymentButton) paymentButton.hidden = !variant.available;
      if (stickyBuyNow) {
        stickyBuyNow.disabled = !variant.available;
        if (stickyBuyNowLabel) stickyBuyNowLabel.textContent = variant.available ? stickyBuyNow.dataset.labelBuyNow : stickyBuyNow.dataset.labelSoldOut;
      }
      setStickyVisibility(stickyVisibilityWanted);
    };

    var gallery = root.querySelector('[data-product-gallery]');
    var slides = gallery ? gallery.querySelectorAll('[data-gallery-slide]') : [];
    var thumbs = gallery ? gallery.querySelectorAll('[data-gallery-thumb]') : [];
    var showImage = function (index) {
      for (var i = 0; i < slides.length; i += 1) {
        slides[i].hidden = i !== index;
      }
      for (var thumb of thumbs) {
        if (Number(thumb.dataset.imageIndex) === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      }
    };

    for (var thumb of thumbs) {
      thumb.addEventListener('click', function (event) {
        showImage(Number(event.currentTarget.dataset.imageIndex));
      });
    }

    var showVariantImage = function (variant) {
      if (!variant.featured_image || !variant.featured_image.id) return;
      for (var i = 0; i < slides.length; i += 1) {
        if (String(slides[i].dataset.imageId) === String(variant.featured_image.id)) {
          showImage(i);
          return;
        }
      }
    };

    var getSelectedVariant = function () {
      var controls = form.querySelectorAll('[data-product-option]');
      var selectedValues = [];
      for (var control of controls) {
        if (control.type === 'radio') {
          if (control.checked) selectedValues[Number(control.dataset.optionIndex)] = control.value;
        } else {
          selectedValues[Number(control.dataset.optionIndex)] = control.value;
        }
      }
      return variants.find(function (variant) {
        if (!variant.options || variant.options.length !== selectedValues.length) return false;
        for (var index = 0; index < variant.options.length; index += 1) {
          if (variant.options[index] !== selectedValues[index]) return false;
        }
        return true;
      });
    };

    var updateVariant = function () {
      var variant = getSelectedVariant();
      if (!variant) return;
      if (variantIdElement) variantIdElement.value = variant.id;
      showPrice(variant);
      showAvailability(variant);
      showVariantImage(variant);
    };

    for (var option of form.querySelectorAll('[data-product-option]')) option.addEventListener('change', updateVariant);

    for (var quantityButton of form.querySelectorAll('[data-quantity-change]')) {
      quantityButton.addEventListener('click', function (event) {
        var input = form.querySelector('.quantity-selector__input');
        if (!input) return;
        var current = Number(input.value) || 1;
        input.value = Math.max(1, current + (event.currentTarget.dataset.quantityChange === 'increase' ? 1 : -1));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    if (stickyBuyNow) {
      stickyBuyNow.addEventListener('click', function () {
        var expressButton = form.querySelector('.shopify-payment-button__button, .shopify-payment-button__button--unbranded');
        if (expressButton && !expressButton.disabled) {
          expressButton.click();
          return;
        }
        if (addButton && !addButton.disabled) addButton.click();
      });
    }

    if (stickyCta) {
      var formActions = form.querySelector('.product-form__actions');
      if ('IntersectionObserver' in window && formActions) {
        var stickyObserver = new IntersectionObserver(function (entries) {
          setStickyVisibility(!entries[0].isIntersecting);
        }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
        stickyObserver.observe(formActions);
      } else {
        setStickyVisibility(true);
      }
    }

    for (var dialogOpener of root.querySelectorAll('[data-dialog-open]')) {
      var dialog = document.getElementById(dialogOpener.dataset.dialogTarget);
      if (!dialog) continue;
      if (!dialog.dataset.bound) {
        dialog.dataset.bound = 'true';
        dialog.addEventListener('close', function (event) {
          var lastTrigger = event.currentTarget.__lastTrigger;
          if (lastTrigger) lastTrigger.focus();
        });
        var dialogZoomToggle = dialog.querySelector('[data-zoom-toggle]');
        var dialogZoomImage = dialog.querySelector('[data-zoom-image]');
        if (dialogZoomToggle && dialogZoomImage) {
          dialogZoomToggle.addEventListener('click', function () {
            var isZoomed = dialogZoomToggle.classList.toggle('is-zoomed');
            dialogZoomImage.classList.toggle('is-zoomed', isZoomed);
            dialogZoomToggle.setAttribute('aria-label', isZoomed ? dialogZoomToggle.dataset.zoomLabelOut : dialogZoomToggle.dataset.zoomLabelIn);
          });
        }
      }
      dialogOpener.addEventListener('click', function (event) {
        var opener = event.currentTarget;
        var target = document.getElementById(opener.dataset.dialogTarget);
        if (!target) return;
        target.__lastTrigger = opener;
        var zoomImage = target.querySelector('[data-zoom-image]');
        var zoomToggle = target.querySelector('[data-zoom-toggle]');
        if (zoomImage) zoomImage.classList.remove('is-zoomed');
        if (zoomToggle) {
          zoomToggle.classList.remove('is-zoomed');
          zoomToggle.setAttribute('aria-label', zoomToggle.dataset.zoomLabelIn || '');
        }
        if (zoomImage && opener.dataset.zoomSrc) {
          zoomImage.src = opener.dataset.zoomSrc;
          zoomImage.alt = opener.dataset.zoomAlt || '';
        }
        if (!target.open) target.showModal();
      });
    }

    if (variants.length === 1) {
      showPrice(variants[0]);
      showAvailability(variants[0]);
    }
  }
}());
